import * as Lucide from "lucide-react";
import { useEffect, useState } from "react";
import { Form, useActionData, useLoaderData, useNavigation } from "react-router";
import type { SubscribeToPublicSourceResult } from "~/.server/source";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { nextEpisodePublishDay } from "~/model/episode";
import { getScheduleLabel } from "~/model/source";
import { useUser } from "../with-user";
import type { action } from "./.server/action";
import type { loader } from "./.server/loader";

function SubscribeSuccess({ data }: { data: SubscribeToPublicSourceResult }) {
  const { episodeTime, locale, timeZone } = data;
  const day = episodeTime && nextEpisodePublishDay({ untilTime: episodeTime }, { locale, timeZone });
  const time = episodeTime?.toLocaleTimeString(locale, { hour: "numeric", minute: "2-digit" });
  return (
    <div className="flex flex-col gap-4 items-center bg-popover p-4 rounded-lg shadow-sm border text-sm w-md">
      <Lucide.CircleCheck className="size-6 text-primary inline-block" />
      {day && time ? `The next summary will be sent to you ${day} at ${time}.` : "You are all set!"}
    </div>
  );
}

export function Subscribe() {
  const user = useUser();
  const data = useActionData<typeof action>();
  // const data = {
  //   subscribeResult: {
  //     timeZone: "Europe/Riga",
  //     locale: "en-US",
  //     episodeTime: new Date("2025-02-15T03:00:00Z"),
  //   },
  // };
  const navigation = useNavigation();
  const { sourceSummary } = useLoaderData<typeof loader>();

  const [opt, setOpt] = useState(null as { timeZone: string; locale: string } | null);
  useEffect(() => {
    const options = Intl.DateTimeFormat().resolvedOptions();
    setOpt({ timeZone: options.timeZone, locale: options.locale });
  }, []);

  if (user) {
    // TODO - support subscribing for logged in users
    return null;
  }

  const canSubmit = navigation.state !== "submitting";

  return data && "subscribeResult" in data ? (
    <SubscribeSuccess data={data.subscribeResult} />
  ) : (
    <Form method="post" className="flex flex-col gap-4 items-center bg-popover p-4 rounded-lg shadow-sm border w-md">
      <Label htmlFor="email">Subscribe to {sourceSummary.source.sourceName} Sumcast</Label>
      <div className="flex flex-row gap-2 self-stretch">
        <Input name="email" type="email" placeholder="Your email" className="grow" />
        <Input name="sourceId" type="hidden" value={sourceSummary.source.sourceId} />
        {opt?.timeZone && <Input name="timeZone" type="hidden" value={opt.timeZone} />}
        {opt?.locale && <Input name="locale" type="hidden" value={opt.locale} />}
        <Button type="submit" name="action" value="subscribe" disabled={!canSubmit}>
          Subscribe
        </Button>
      </div>
    </Form>
  );
}
